
import { PropType, defineComponent } from 'vue'

export default defineComponent({
    props: {
        startColor: {
            type: String as PropType<string>,
            default: () => '#EFD28C'
        },
        endColor: {
            type: String as PropType<string>,
            default: () => '#A18341'
        }
    }
})
